// Shared Lumacofono addresses for this project only (not synced with the other Emergent apps).
export const HOME_URL = "https://www.lumacofono.com";

export const EXPERIENCES = [
  { id: "teorie", label: "Le teorie dal mondo", hint: "Misteri e teorie su One Piece", href: "https://www.lumacofono.com" },
  { id: "fruttipedia", label: "Fruttipedia", hint: "L'enciclopedia dei Frutti del Diavolo", href: "https://fruttipedia.lumacofono.com" },
  { id: "ciurma", label: "Crea la tua ciurma", hint: "Il gioco: fin dove arriverai?", href: "https://ciurma.lumacofono.com", current: true },
  { id: "sbustaop", label: "SbustaOP", hint: "Il gioco di apertura pacchetti", href: "https://sbustaop.lumacofono.com" },
];

export const SOCIAL_LINKS = [
  { id: "spotify", label: "Spotify", href: "https://open.spotify.com/show/2QRg3xuiNzzMweAuAr46zT" },
  { id: "youtube", label: "YouTube", href: "https://youtube.com/@lumacofonopodcast" },
  { id: "instagram", label: "Instagram", href: "https://www.instagram.com/lumacofono_podcast" },
  { id: "tiktok", label: "TikTok", href: "https://www.tiktok.com/@lumacofono.podcast" },
  { id: "twitch", label: "Twitch", href: "https://twitch.tv/lumacofono" },
];

// Domain printed on the result picture / share text. Switch to "ciurma.lumacofono.com" when the move is done.
export const SHARE_DOMAIN_LABEL = "lumacofono.com";

// Browser-data transfer to the new subdomain: set enabled=true only during the move (both domains live).
export const MIGRATION = {
  enabled: false,
  targetOrigin: "https://ciurma.lumacofono.com",
  oldHostname: "www.lumacofono.com",
};
